import React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";

import DiscountSubTotal from "../priceWorksheet/discountSubTotal";
import DiscountCommon from "../priceWorksheet/discountCommon";
import {DISCOUNT_MAIN_TYPES, DISCOUNT_TYPES} from "../priceWorksheet/discounstInterface";
import {getDiscountCurrentValue, getTotalForDeposit} from "../priceWorksheet/discountFunctions";
import {getPriceWithCurrency, getQuotePriceWithTaxes, getTotalPrice} from "../../misc/helpers";


class ShoppingCartDiscountsListItem extends DiscountCommon {

  static propTypes = {
    discountSection: PropTypes.object.isRequired,
    discount: PropTypes.object.isRequired,
  };

  render() {
    const {discount, discountSection, activeQuoteIndex, hasMultipleWorkSheets, financeActiveDiscount,
      fabricatorSettings} = this.props;

    const realName = getDiscountCurrentValue(discount, "name", activeQuoteIndex, hasMultipleWorkSheets);

    const isDeposit = discount.discountType === DISCOUNT_MAIN_TYPES.deposit;
    const isFinancedAmount = discount.discountType === DISCOUNT_MAIN_TYPES.financedAmount;

    if (isFinancedAmount && !financeActiveDiscount) {
      return null;
    }

    if (isDeposit || isFinancedAmount) {
      const totalPrice = isDeposit ? getTotalForDeposit(activeQuoteIndex, hasMultipleWorkSheets) : getTotalPrice();
      const totalAmount = getQuotePriceWithTaxes(totalPrice);
      const showAdditionalInfo = totalAmount && discount.type === DISCOUNT_TYPES.percent;

      return (
        <li className={"scart-block__list-item scart-block__list-item--centered discount--deposit"}>
          <div className={"margin-l-10 margin-t-6 margin-b-6 scart-block__list-item-text discount-cell--name bold"}>
            {realName}
          </div>
          <div className="flex flex--center">
            {showAdditionalInfo ? (
              <div className="bold color-gray4" style={{paddingRight: "0.5rem"}}>
                <span>Deposit </span>
                <span className="price--gray"> {discount.amount}%</span>
                <span> of </span>
                <span className="price--gray">{getPriceWithCurrency(fabricatorSettings, totalAmount)}</span>
                <span> = </span>
              </div>
            ) : null}
            {/*<span className={"margin-r-8" + (fabricatorData.isRenuit ? " color-primary bold" : " price price--gray")}>*/}
            <span className={"margin-r-8 color-primary bold"}>
              {this.getInputValue()}
            </span>
          </div>
        </li>
      )
    }

    return (
      <li className="scart-block__list-item scart-block__list-item--centered">
        <div className="scart-block__list-item-text">
          <h4 className={"scart-block__list-item-text-title"
          + (discount.isSubTotal ? " scart-block__list-item-text-title--green": "")}>{realName}</h4>
        </div>
        <div className="shoppingcart-block__list-item-total">
          <span className={"price " + (discount.isSubTotal ? "price--blue" : "price--active")}>
            {discount.isSubTotal
              ? <DiscountSubTotal discount={discount}
                                  quoteIndex={activeQuoteIndex}
                                  discountSection={discountSection}
                                  shoppingCartItem={true}/>
              : this.getDiscountAmount()}
          </span>
        </div>
      </li>
    )
  }
}

const mapStateToProps = (store, ownProps) => {
  const {discountSections, customAddedDiscounts, financeActiveDiscount} = store.priceWorksheetState;
  const {allWizardsValues} = store.wizardState;
  const {activeQuoteIndex, quotes} = store.quotesState;
  const {jobIsSaving} = store.serverState;
  const {showAllQuotesCartItemsList} = store.cartState;

  return {
    discountSections,
    customAddedDiscounts,
    financeActiveDiscount,
    fabricatorData: store.fabricatorState,
    fabricatorSettings: store.fabricatorState.settings,
    // Total requirements
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    // Total requirements end
    allWizardsValues,
    activeQuoteIndex: Number.isInteger(ownProps.quoteIndex) ? ownProps.quoteIndex : activeQuoteIndex,
    jobIsSaving,
    showAllQuotesCartItemsList,
    quotes,
  };
};

export default connect(mapStateToProps, {

})(ShoppingCartDiscountsListItem);
